const gallerySafetyFeatures = [
  'Active Lane Keep Assistance',
  'Adaptive Cruise Control',
  'Automatic Emergency Braking',
  'Blindspot Sensors',
  'Heads Up Display'
];

export default gallerySafetyFeatures;
